import { TranslateService } from '@ngx-translate/core';
import { ApplicationPermissionItem, CustomerSpaceUserModel } from '../customer-space-user.model';
import { AppPermissionTypes } from '../app-permission-helper';

export function mapToCustomerSpaceUser(user: any, tr: TranslateService): CustomerSpaceUserModel {
  const arr = 'Tasks | Payroll | Links | Financial Statement Workings | Tax Declaration | Documents | Projects | Accounts payable | Audit'
    .split('|')
    .filter((s) => !!s)
    .map((s) => s.trim());

  // get random index value
  const randomIndex = Math.floor(Math.random() * arr.length);

  //randomIndex = 1;

  const subArr = arr.slice(0, randomIndex);

  return {
    id: user.id,
    userName: {
      firstName: user.firstName,
      lastName: user.lastName,
      role: user.customerSpaceRole?.name,
      isContact: user.isContact,
      isDeputy: user.isDeputy,
      deputyFromName: user.deputyFromName,
    },
    account: {
      isActive: user.isActive,
      isInternal: user.isInternal,
    },
    applications: subArr.map(
      (e) =>
        ({
          text: e,
        }) as ApplicationPermissionItem,
    ),
    organizationUnit: user.organizationUnit,
  };
}

export function transformUsers(data: any[], tr: TranslateService): CustomerSpaceUserModel[] {
  return data.map((u) => mapToCustomerSpaceUser(u, tr));
}

export function concatCustomerUserFields(data: CustomerSpaceUserModel, tr: TranslateService): string {
  const activeT = tr.instant('users.active');
  const inactiveT = tr.instant('users.inactive');
  const arr: string[] = [
    data.userName.firstName,
    data.userName.lastName,
    data.userName.isContact ? 'Contact' : '',
    data.userName.deputyFromName,
    data.userName.deputyText,
    data.organizationUnit,
    data.userName.roleText || '',
    data.account.isActive ? activeT : inactiveT,
    data.account.isInternal ? 'Internal' : 'External',
    data.id,
    ...data.applications.map((e) => e.text),
  ];

  return arr
    .filter((item) => item != null)
    .map((item) => item.toLowerCase())
    .join(',');
}

/** Simple sort comparator for example ID/Name columns (for client-side sorting). */

export function compare(a: string | number, b: string | number, isAsc: boolean, ignoreCase = true): number {
  if (ignoreCase && typeof a === 'string' && typeof b === 'string') {
    return a.localeCompare(b, undefined, { sensitivity: 'accent' }) * (isAsc ? 1 : -1);
  }
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}

export function compareDate(a: Date | null | undefined, b: Date | null | undefined, isAsc: boolean): number {
  const aTime = a != null ? a.getTime() : 0;
  const bTime = b != null ? b.getTime() : 0;
  return compare(aTime, bTime, isAsc);
}

export function getDateAsNumber(a: Date | null | undefined): number {
  if (a instanceof Date) {
    return a.getTime();
  }
  return 0;
}

export const appPermissionsMap = {
  [AppPermissionTypes.TASKS]: { enabled: false, translKey: 'tasks' },
  [AppPermissionTypes.DOCUMENTS]: { enabled: false, translKey: 'documents' },
  [AppPermissionTypes.PAYROLL]: { enabled: false, translKey: 'payroll' },
  [AppPermissionTypes.PROJECTS]: { enabled: false, translKey: 'projects' },
  [AppPermissionTypes.LINKS]: { enabled: false, translKey: 'links' },
  [AppPermissionTypes.CREDITOR]: { enabled: false, translKey: 'creditor' },
  [AppPermissionTypes.FILE_PROCESS_FINANCIAL_STATEMENT_WORKINGS]: { enabled: false, translKey: 'financialStatementWorkings' },
  [AppPermissionTypes.FILE_PROCESS_AUDIT]: { enabled: false, translKey: 'audit' },
  [AppPermissionTypes.FILE_PROCESS_TAX_DECLARATION]: { enabled: false, translKey: 'taxDeclaration' },
};

// not used yet
const allPermissions = [
  AppPermissionTypes.TASKS,
  AppPermissionTypes.DOCUMENTS,
  AppPermissionTypes.PAYROLL,
  AppPermissionTypes.PROJECTS,
  AppPermissionTypes.LINKS,
  AppPermissionTypes.CREDITOR,
  AppPermissionTypes.FILE_PROCESS_FINANCIAL_STATEMENT_WORKINGS,
  AppPermissionTypes.FILE_PROCESS_AUDIT,
  AppPermissionTypes.FILE_PROCESS_TAX_DECLARATION,
];
